import './primary-button.component.scss';
import { Link, To } from 'react-router';

type PrimaryButtonProps = {
    title: string;
    className?: string;
    onClick?: () => void;
    to: To;
} & any;

const PrimaryLink = ({ className, title, ...props }: PrimaryButtonProps) => (
    <Link className={`primary-button ${className || ''}`} {...props}>
        {title}
    </Link>
);

export default PrimaryLink;
